export function vekaletBankaHesabinaDonustur(hesap: any): any {
  if (!hesap) return hesap;

  return {
    ...hesap,
    id: hesap.id ?? hesap.banka_hesap_id,
    isim: hesap.isim ?? hesap.banka_hesap_ismi,
    hesap_no: hesap.hesap_no ?? hesap.hesap_numarasi,
    para_birim_kodu: hesap.para_birim_kodu ?? hesap.kisa_isim,
    banka_hesap_id: hesap.banka_hesap_id ?? hesap.id,
    banka_hesap_ismi: hesap.banka_hesap_ismi ?? hesap.isim,
    hesap_numarasi: hesap.hesap_numarasi ?? hesap.hesap_no,
    kisa_isim: hesap.kisa_isim ?? hesap.para_birim_kodu,
  };
}

export function varsayilanVekaletBankaHesabiniBul(
  hesaplar: any[],
  vekalet: any
): any | null {
  const varsayilanId = vekalet?.varsayilan_banka_hesabi?.banka_hesap_id
    ?? vekalet?.varsayilan_banka_hesabi_id;

  if (varsayilanId === null || varsayilanId === undefined) return null;

  return hesaplar.find((hesap: any) =>
    hesap?.banka_hesap_id !== null
    && hesap?.banka_hesap_id !== undefined
    && String(hesap.banka_hesap_id) === String(varsayilanId)
  ) ?? null;
}
